import { Injectable } from '@angular/core';
import { ServiceConfig } from 'app/_services/service-config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BrandService {
    private host = ServiceConfig.host;
    private baseUrl = this.host +  '/api/FBPriority/';
    private BASE_URL = this.host + '/api/brand-manage';
    private httpHeaders = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    private httpParams = new HttpParams().set('token', JSON.parse(localStorage.getItem('currentSmmData')).token);

    constructor(private httpClient: HttpClient) {
    }

    getAll(): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/getList`, {}, { params: this.httpParams, headers: this.httpHeaders });
    }


    create(newBrand): Observable<any> {
        let data = JSON.parse(localStorage.getItem('currentSmmData'));
        let url = this.BASE_URL + '/create?token=' + data.token;
        return this.httpClient.post<any>(url, newBrand);
        // return this.httpClient.post(`${this.BASE_URL}/create`, newBrand, { params: this.httpParams, headers: this.httpHeaders });
    }

    update(brandItem): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/update`, brandItem, { params: this.httpParams, headers: this.httpHeaders });
    }
    updateMainBrand(brandItem): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/updateMainBrand`, brandItem, { params: this.httpParams, headers: this.httpHeaders });
    }

    delete(id): Observable<any> {
        return this.httpClient.get(this.BASE_URL + `/delete/${id}`, { params: this.httpParams, headers: this.httpHeaders });
    }

    public getInfoFBPriority(body) {
        let data = JSON.parse(localStorage.getItem('currentSmmData'));
        let url = this.baseUrl + 'add?token=' + data.token;
        return this.httpClient.post<any>(url, body);
    }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/brand-manage/brands.service.ts